import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

const Activities = () => {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchActivities = async () => {
            try {
                const response = await axios.get('https://marcsri.com/api/activities');
                setActivities(response.data);
            } catch (err) {
                console.error('Error fetching activities:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchActivities();
    }, []);

    // Determine image columns based on screen width
    const getImageColumns = () => {
        if (windowWidth < 576) { // Mobile portrait
            return 1;
        } else if (windowWidth >= 576 && windowWidth < 768) { // Mobile landscape / small tablet
            return 2;
        } else if (windowWidth >= 768 && windowWidth < 992) { // Tablet portrait
            return 2;
        } else if (windowWidth >= 992 && windowWidth < 1200) { // Tablet landscape
            return 3;
        } else { // Desktop
            return 3;
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="ms-3 mb-0">Loading activities...</p>
            </div>
        );
    }

    return (
        <div className="container py-3 py-md-5">
            <h2 className="text-center fw-bold mb-4 mb-md-5" style={{
                fontFamily: 'Georgia',
                fontSize: windowWidth < 768 ? '1.75rem' : '2.5rem'
            }}>
                Our Activities
            </h2>

            {activities.length === 0 ? (
                <div className="text-center py-5">
                    <p className="fs-5">No activities found.</p>
                </div>
            ) : (
                <div className="row justify-content-center g-4">
                    {activities.map((activity) => (
                        <div key={activity._id} className="col-12 mb-4 mb-md-5">
                            <h3 className="text-center fw-bold mb-3 mb-md-4" style={{
                                fontFamily: 'Georgia',
                                fontSize: windowWidth < 768 ? '1.5rem' : '2rem'
                            }}>
                                {activity.name}
                            </h3>
                            <div className="row justify-content-center g-3">
                                {activity.images && activity.images.length > 0 ? (
                                    activity.images.map((url, index) => (
                                        <div
                                            key={index}
                                            className={`col-${12 / getImageColumns()} col-md-${windowWidth >= 992 ? 4 : 6}`}
                                        >
                                            <div className="ratio ratio-1x1">
                                                <img
                                                    src={`https://marcsri.com${url}`}
                                                    alt={`${activity.name} ${index + 1}`}
                                                    className="img-fluid rounded"
                                                    style={{
                                                        objectFit: 'cover',
                                                    }}
                                                    onError={(e) => {
                                                        e.target.src = '/placeholder.jpg';
                                                        e.target.className = 'img-fluid rounded bg-light';
                                                    }}
                                                    loading="lazy"
                                                />
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center py-3">
                                        <p className="text-muted">No images available</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Activities;